import React from "react";
import {
  Box,
  Paper,
  Typography,
  Divider,
  Link,
  makeStyles
} from "@material-ui/core";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import Button from "components/CustomButtons/Button.js";
const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "60vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(2),
  },
  card: {
    maxWidth: 720,
    width: "100%",
    padding: theme.spacing(4),
    borderRadius: 12,
  },
  header: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    gap: theme.spacing(1.5),
  },
  icon: {
    color: theme.palette.error.main,
    fontSize: 36,
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
}));

function titleFromError(err) {
  if (!err) return "Form unavailable";
  const e = String(err).toLowerCase();
  if (e.includes("removed")) return "Project not found";
  if (e.includes("not published")) return "Form not published or closed";
  return "Form unavailable";
}

export default function PublicFormError({
  error,
  contactEmail = "info@qusandbox.com",
  homeHref = "/",
}) {
  const classes = useStyles();
  const title = titleFromError(error);

  return (
    <Box className={classes.root}>
      <Paper elevation={3} className={classes.card} role="alert" aria-live="assertive">
        <div className={classes.header}>
          <ErrorOutlineIcon className={classes.icon} />
          <Typography variant="h5">{title}</Typography>
        </div>

        <Typography variant="body1" color="textSecondary" gutterBottom>
          {error || "We couldn’t load this form."}
        </Typography>

        <Divider style={{ margin: "16px 0" }} />

        <Typography variant="body2" color="textSecondary">
          If you feel this is a mistake, contact{" "}
          <Link href={`mailto:${contactEmail}`}>{contactEmail}</Link>.
        </Typography>

        <div className={classes.actions}>
        
          <Button href={homeHref} variant="contained" color="quSandBoxColor">
            Go to homepage
          </Button>
        </div>
      </Paper>
    </Box>
  );
}
